import { useEffect, useState } from "react";
import useAuth from "@/hooks/useAuth";
import { PricingModal } from "@/ui-components/PricingModal";
import { trackDemoView, trackTrialCtaClick } from "@/utils/gtm";

interface DemoBannerProps {
  /** Custom message to display (defaults to "Viewing 24-hour delayed data") */
  message?: string;
}

export function DemoBanner({ message = "24-hour delayed" }: DemoBannerProps) {
  const { keycloakInstance: keycloak } = useAuth();
  const [isPricingOpen, setIsPricingOpen] = useState(false);

  // Arrival at the demo. The marketing site records the click that sends
  // someone here; this is the first record that they got here.
  useEffect(() => {
    trackDemoView({ surface: "demo_banner" });
  }, []);

  return (
    <>
      <PricingModal isOpen={isPricingOpen} onClose={() => setIsPricingOpen(false)} />
    <div className="hidden sm:flex items-center justify-center gap-6 bg-gray-900 border-b border-gray-800 py-2.5 px-4">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-terminal-orange opacity-60" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-terminal-orange" />
          </span>
          <span className="text-xs font-semibold text-terminal-orange uppercase">Demo</span>
        </div>
        <span className="text-xs text-gray-500">—</span>
        <span className="text-xs text-gray-400">
          Viewing <span className="text-terminal-orange">{message}</span> data
        </span>
      </div>

      <div className="flex items-center gap-2">
        <button
          className="px-3 py-1 text-xs font-medium text-white bg-squawk-blue hover:bg-squawk-blue/80 rounded-md transition-colors cursor-pointer"
          onClick={() => {
            trackTrialCtaClick({ surface: "demo_banner" });
            setIsPricingOpen(true);
          }}
        >
          Get Live Data
        </button>
        <button
          className="px-3 py-1 text-xs font-medium text-gray-300 bg-gray-700/40 hover:bg-gray-600 rounded-md transition-colors cursor-pointer"
          onClick={() => keycloak?.login()}
        >
          Login
        </button>
      </div>
      </div>
    </>
  );
}

export default DemoBanner;
